import { render, staticRenderFns } from "./m-select-currency.vue?vue&type=template&id=60202274&scoped=true&"
import script from "./m-select-currency.vue?vue&type=script&lang=js&"
export * from "./m-select-currency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60202274",
  null
  
)

export default component.exports